import { createStore as reduxCreateStore } from "redux";
import reducers from "../reducers/index.js";

const createStore = () => reduxCreateStore(reducers);
export default createStore;
